import axios from 'axios';
import { API_BASE_URI } from 'library/constants/api';

const API_BASE_URL = `${API_BASE_URI}/notification`;

export interface RegisterDevicePayload {
  deviceToken: string;
  deviceType: 'ANDROID' | 'IOS' | 'WEB';
  deviceId: string;
}

export const NotificationService = {
  registerDevice: async (payload: RegisterDevicePayload): Promise<any> => {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    } as const;

    try {
      const response = await axios
        .post(`${API_BASE_URL}/registerDevice`, payload, { headers })
        .catch((error) => {
          if (error?.response?.status === 403) {
            localStorage.clear();
            sessionStorage.clear();
            window.open('/sign-in', '_self');
          }
          throw error;
        });
      return response?.data;
    } catch (error) {
      console.error('Failed to register device:', error);
      throw error;
    }
  },
};

export default NotificationService;

// Ensure this file is treated as a module in all TS tooling
export {};
